<template>
    <div class="notification-center">
        <base-alert
            v-for="(notification, index) in notifications"
            :index="index"
            :key="index"
            :type="notification.type"
            :message="notification.message"
            :removable="true"
            @remove="remove(index)"
        />
    </div>
</template>

<script>
import { EventBus } from 'relapp-event';
import BaseAlert from './atoms/BaseAlert.vue';

export default {
    components: {
        BaseAlert
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            notifications: [],
            timer: null,
            timeout: 5000
        };
    },
    /**
     * Runs code after an instance is created.
     */
    created() {
        EventBus.$on('notification', this.add);
        EventBus.$on('clearNotification', this.clear);
    },
    methods: {
        /**
         * Add a new notification to the notification array.
         *
         * @param {object} notification
         */
        add(notification) {
            this.notifications.unshift(notification);

            if (this.notifications.length < 2) {
                return;
            }

            this.timer = setTimeout(() => {
                this.notifications.pop();
            }, this.timeout);
        },

        /**
         * Remove a notification from the notification array.
         *
         * @param {object} index
         */
        remove(index) {
            this.notifications.splice(index, 1);
        },

        /**
         * Remove a notification from the notification array.
         */
        clear() {
            this.notifications = [];
        }
    }
};
</script>
